import { cva, type VariantProps } from 'class-variance-authority'
import type { ComponentProps } from 'react'
import { Badge } from '@/components/ui/badge'
import { cn } from '@/utils/cn'
import { PILL, PILL_TONE } from '../recipes'

/** Tone (the PILL_TONE surfaces) and size of a HUMINT status pill. */
export const pillVariants = cva(PILL, {
  variants: {
    tone: PILL_TONE,
    size: {
      /** 24 px, one line. */
      default: '',
      /** 20 px: inside dense rows and the side nav. */
      compact: 'h-5 px-2 text-[11px]',
      /** Grows to wrap a long label onto more lines. */
      wrap: 'h-auto min-h-6 py-0.5 whitespace-normal',
    },
  },
  defaultVariants: { tone: 'neutral', size: 'default' },
})

export type PillProps = Omit<ComponentProps<typeof Badge>, 'variant'> &
  VariantProps<typeof pillVariants>

/**
 * A status pill: icon (optional) + words on a token surface. Never Badge's own faint
 * `warning` / `info` variants. State needs words, not colour alone.
 */
export function Pill({ tone, size, className, ...props }: PillProps) {
  return (
    <Badge variant="outline" className={cn(pillVariants({ tone, size }), className)} {...props} />
  )
}
